import axios from 'axios';

import { API_URL } from '../constants';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

function resetToken() {
  localStorage.removeItem('token');
  api.defaults.headers.common['Authorization'] = null;
}

export { api, resetToken };
